export enum MemberType {
  'Normal' = 0,
  'Suspicious' = 1
}
